module.exports = __webpack_public_path__ + "img/helal-ahmar.5b65675.svg";